import View from 'scripts/poppet/view';
import template      from 'templates/unitDetails.jst.html';

const selectors = {
	regionContainer : '[data-region=details-container]',
	upgradeButton   : '[data-click=upgrade-firmware]',
	closeButton           : '[data-click=details-close]',
	
};

const channel = Bb.Radio.channel( 'objects' ),
	  channelLayout = Bb.Radio.channel( 'layout' );


const UnitDetailsView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	
	ui: {
		upgradeFirmware : selectors.upgradeButton,
		close   : selectors.closeButton
	},
	
	events: {
		'click @ui.upgradeFirmware' : 'onClickUpgradeFirmware',
		'click @ui.close'  : 'onClickClose'
	},
	
	modelEvents: {
		'change:transientOffline': 'onConnectionChanged',
		'change:transientUpgradeAvailable': 'onUpgradeAvailableChanged',
		'change:transientApiVersion' : 'onApiVersionChanged',
	},
	
	templateContext: function () {
		return{
			serial              : this.model.get( 'serialNumber' ) || '&nbsp;',
			showSerialNumber    : true,
			showTestResult      : true,
			showApiVersion      : this.model.get( 'transientApiVersion' ) !== null,
			apiVersion          : this.model.get( 'transientApiVersion' ) || '&nbsp',
			upgradeAvailable    : this.model.get( 'transientUpgradeAvailable' ),
			offline             : this.model.get( 'transientOffline' ),
			unitType            : this.model.getUnitType(),
			subscriptionName    : this.model.subscriptionName(),
			customerName        : this.model.customerName(),
			vehicleName         : this.model.vehicleName(),
			alarmCentralName    : this.model.alarmCentralName(),
			insuranceCompanyName: this.model.insuranceCompanyName(),
		};
	},
	
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	onClickClose: function(){
		this.trigger('close', this)
	},
	
	/**
	 * Triggers when the model changes the transientOffline attribute.
	 * @void
	 */
	onConnectionChanged: function( event ) {
		this.evaluateUpgradeButton();
	},
	
	/**
	 * Triggers when the model changes the transientUpgradeAvailable attribute.
	 * @void
	 */
	onUpgradeAvailableChanged: function( event ) {
		this.evaluateUpgradeButton();
	},
	
	/**
	 * Triggers when the model changes the transientApiVersion attribute.
	 * @void
	 */
	onApiVersionChanged: function( event ) {
		if(this.$el.find('.api-version')) {
			this.$el.find('.api-version').html(this.model.get( 'transientApiVersion' ));
		} else {
			this.render();
		}
	},
	
	
	/**
	 * Triggers when the user clicks the "upgrade" button.
	 * @void
	 */
	
	onClickUpgradeFirmware : function ( ) {
		event.preventDefault();
		this.trigger( 'upgrade', this);
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	evaluateUpgradeButton: function () {
		let offline = this.model.get('transientOffline'),
			upgradeAvailable = this.model.get('transientUpgradeAvailable'),
			upgradeButtonHidden = this.$el.find('.upgrade-button').hasClass('no-upgrade');
		
		if( !offline && upgradeAvailable && upgradeButtonHidden) {
			this.$el.find('.upgrade-button').removeClass('no-upgrade');
		} else if((!upgradeAvailable && !upgradeButtonHidden) ||
				  (offline && !upgradeButtonHidden)) {
			this.$el.find('.upgrade-button').addClass('no-upgrade')
		}
		
	},
	
} );


export default UnitDetailsView;
